import { render, staticRenderFns } from "./CompetencyForm.vue?vue&type=template&id=1ecd30c6"
import script from "./CompetencyForm.vue?vue&type=script&lang=js"
export * from "./CompetencyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports